module.exports = __webpack_public_path__ + "static/media/18_B.ab23f23c.png";